import billingService from '@/modules/billing/services/billingService';

const state = {
  billingAccount: undefined,
};

const mutations = {
  setBillingAccount(state, value) {
    state.billingAccount = value;
  },
};

const actions = {
  async loadBillingAccount({ commit, state }) {
    if (!state.billingAccount) {
      const billingValue = await billingService.getBillingAccount();
      commit('setBillingAccount', billingValue);
    }
  },
};

const getters = {
  billingAccount: (state) => state.billingAccount,
  // `billingApp` is an AppsStore *getter*, not state — reading it off rootState always yielded
  // undefined, which short-circuited this whole expression and leaked "undefined" into the
  // has_account query param of the checkout URL. Coerced to a boolean so a negative answer
  // serializes as "false" rather than "undefined"/"null". (VCITA2-15038)
  isValidBillingAccount: (state, _, __, rootGetters) => !!rootGetters['AppsStore/billingApp']
    && !!state.billingAccount
    && state.billingAccount.code !== 'error'
    && state.billingAccount.billing_app_account_data?.validation_code === 'valid',
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
